import React, { useEffect, useState, useRef, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../../api/services/AuthService";
import { ApiConfig } from "../../api/apiConfig/apiConfig";
import { ProfileContext } from "../../context/ProfileProvider";
import { alertErrorMessage, alertSuccessMessage } from "../CustomAlertMessage";

const UserHeader = () => {

  const [searchPair, setSearchPair] = useState("");
  const [pairs, setPairs] = useState([]);
  const [allData, setAllData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [apkLink, setApkLink] = useState("");

  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const getPairs = async () => {
    const result = await AuthService.getPairs();
    if (result?.success) {
      setPairs(result?.data);
      setAllData(result?.data);
    }
  };



  useEffect(() => {
    getPairs();
  }, []);

  useEffect(() => {
    if (searchPair) {
      const filteredPair = allData?.filter((item) =>
        item?.base_currency?.toLowerCase()?.includes(searchPair?.toLowerCase())
      );
      setPairs(filteredPair);
    } else {
      setPairs(allData);
    }
  }, [searchPair]);

  // 👇 outside click closes dropdown and mobile nav
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  const toggleNavbar = () => setIsOpen(!isOpen);

  const nextPage = (data) => {
    sessionStorage.setItem("RecentPair", JSON.stringify(data));
    navigate(`/trade/${data?.base_currency}_${data?.quote_currency}`);
    window.location.reload();
  };

  const loginPage = () => navigate(`/login`);
  const signupPage = () => navigate(`/signup`);

  const getApkLink = async () => {
    const result = await AuthService.getApk()
    if (result?.success) {
      setApkLink(result?.data?.apk || "");
    } else {
      alertErrorMessage(result?.message || 'APK download link not available');
    }
  };

  useEffect(() => {
    getApkLink();
  }, []);

  const DownloadApkButton = () => {
    window.location.href = `${ApiConfig?.baseUrl}${apkLink}`;
  }

  return (
    <header className="sticky-top">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-2 logo_s">
            <div className="logo">
              <Link to="/">
                <img className='lightlogo' src="/images/Vorienx_white.svg" alt="logo" />
              </Link>
            </div>
          </div>

          <div className="col-lg-7 navigation_s">
            <div className="navigation" ref={dropdownRef}>
              <nav className="navbar navbar-expand-lg">
                <button className="navbar-toggler" type="button" onClick={toggleNavbar}>
                  <span className="navbar-toggler-icon">
                    <img src="/images/toggle_icon.svg" alt="toggle" />
                  </span>
                </button>
                <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="mainNavbar">
                  <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                    <li className="nav-item">
                      <Link className="nav-link" to="/" onClick={toggleNavbar}>
                        Home
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/market" onClick={toggleNavbar}>
                        Market
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link className="nav-link" to="/trade/BTC_USDT" onClick={toggleNavbar}>
                        Trade
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link className="nav-link" to="/copy-trading" onClick={toggleNavbar}>
                        Copy Trading
                      </Link>
                    </li>

                    {/* <li className="nav-item">
                      <Link className="nav-link" to="/refer_earn" onClick={toggleNavbar}>
                        Refer & Earn
                      </Link>
                    </li> */}

                    <li className="nav-item mememenu">
                      <Link className="nav-link" to="/meme" onClick={toggleNavbar}>
                        Meme+
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link className="nav-link" to="/blogs" onClick={toggleNavbar}>
                        Blogs & News
                      </Link>
                    </li>


                  </ul>
                </div>
              </nav>
            </div>
          </div>

          <div className="col-lg-3">
            <div className="header_right">
              <div className="button_outer">
                <a className="search_icon" href="#" data-bs-toggle="modal" data-bs-target="#exampleModal">
                  <i className="ri-search-line"></i>
                </a>
                <button
                  className="download_icon"
                  type="button"
                  title="Download App"
                  target="_blank"
                  onClick={DownloadApkButton}
                  style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                >
                  <i className="ri-download-cloud-2-line"></i>
                </button>
                <button className="login_btn sign_btn" onClick={loginPage}>
                  <Link to="/login">Log In</Link>
                </button>
                <button className="login_btn" onClick={signupPage}>
                  <Link to="/signup">Sign Up</Link>
                </button>
                {/* <div className="themecolor_icon" onClick={() => (setThemeUpdated(!themeUpdated))}>
                  <i className="ri-moon-line dark-text"></i>
                  <i className="ri-sun-line light-text"></i>
                </div> */}
              </div>
            </div>
          </div>

          {/* Modal Search */}
          <div className="modal fade search_form" id="exampleModal" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-body">
                  <form>
                    <input
                      type="search"
                      placeholder="Search here..."
                      value={searchPair}
                      onChange={(e) => setSearchPair(e.target.value)}
                    />
                  </form>
                  <div className="hot_trading_t">
                    <h3>Hot Trading Pairs</h3>
                    <div className="table-responsive">
                      <table>
                        <tbody>
                          {pairs?.map((item) => (
                            <tr key={item?._id}>
                              <td onClick={() => nextPage(item)}>
                                <div className="td_first">
                                  <div className="icon">
                                    <img
                                      src={ApiConfig?.baseImage + item?.icon_path}
                                      alt="icon"
                                      width="40px"
                                    />
                                  </div>
                                  <div className="price_heading">
                                    {item?.base_currency} / {item?.quote_currency}
                                    <br />
                                    <span>{item?.base_currency_fullname}</span>
                                  </div>
                                </div>
                              </td>
                              <td className="right_t price_tb">
                                {item?.buy_price}
                                <span className={item?.change_percentage > 0 ? "green" : "red"}>
                                  {item?.change_percentage}%
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default UserHeader;

